import React from 'react';
import { Section } from './ui/Section';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'First night: 40 minutes in the bassinet. By night 3, a full 2-hour stretch. I actually slept.',
    author: 'Sarah M.',
    detail: 'Mom of 6-week-old'
  }, {
    quote: "I was so scared I'd fall asleep holding her. This gave me a plan instead of panic.",
    author: 'Jessica T.',
    detail: 'Mom of 3-week-old'
  }, {
    quote: 'The ladder changed everything. When a transfer failed, I finally knew what to try next instead of just crying.',
    author: 'Emily R.',
    detail: 'Mom of 9-week-old'
  }];
  return <Section className="!py-12" data-id="element-179">
      <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#faf6f0] mb-12 text-center" data-id="element-180">
        Parents finally getting sleep
      </h2>
      <div className="grid md:grid-cols-3 gap-6" data-id="element-181">
        {testimonials.map((t, i) => <div key={i} className="bg-[#1a1a2e] p-6 rounded-lg border border-[#c9a96e]/15 shadow-lg flex flex-col" data-id="element-182">
            <div className="flex gap-1 mb-4 text-[#c9a96e]" data-id="element-183">
              {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="#c9a96e" data-id="element-184" />)}
            </div>
            <p className="text-[#f5f0e8] text-lg leading-relaxed mb-6 flex-grow italic" data-id="element-185">
              "{t.quote}"
            </p>
            <div className="mt-auto" data-id="element-186">
              <p className="font-bold text-[#faf6f0]" data-id="element-187">{t.author}</p>
              <p className="text-[#d4cfc5] text-sm" data-id="element-188">{t.detail}</p>
            </div>
          </div>)}
      </div>
    </Section>;
}